// extracted by mini-css-extract-plugin
module.exports = {"list":"OrganizationSetupSubMenu_list__2K8Xu","selectedItem":"OrganizationSetupSubMenu_selectedItem__3sqrI"};